import _get from 'lodash/get'

import axios from '../../_framework/axios/trip-dashboard-axios'
import {
  create,
  fetchResources,
  forOwner,
  forQuery,
  set,
  update
} from '../../_stores/_storeMethods'

const baseUrl = '/trip-dashboard/resource-store-templates'
const dataNamespace = 'appInitialData.stores.ResourceStoreTemplates'

export default {
  namespaced: true,
  state: {
    // set Bags, there may be defaults set under window.appInitialData
    collection: _get(window, `${dataNamespace}.collection`, [])
  },
  mutations: {
    set
  },
  actions: {
    fetch(context) {
      return fetchResources(context, baseUrl, 'collection', {})
    },
    create(context, payload) {
      return create(context, `${baseUrl}/create`, payload, 'collection', {})
    },
    update(context, payload) {
      return update(
        context,
        `${baseUrl}/${payload.template.id}/update`,
        { data: payload.data },
        'collection',
        {}
      )
    },
    remove(context, payload) {
      return update(context, `${baseUrl}/${payload.template.id}/delete`, {}, 'collection', {})
    },
    import(context, payload) {
      return new Promise(resolve => {
        axios
          .post(
            `${baseUrl}/${payload.template.id}/import/${context.rootGetters.currentTripDashboardId}`
          )
          .then(res => {
            if (res.status === 200) {
              context.dispatch('AttachmentsV2/fetch', {}, { root: true }).then(() => {
                resolve(res.data)
              })
            }
          })
      })
    }
  },
  getters: {
    forOwner,
    forQuery
  }
}
